<template>
  <div class="d-flex">
    <v-select
      v-model="sport"
      :prepend-icon="icon"
      :items="items"
      @change="setSelectSport"
      hide-details
      solo-inverted
      return-object
      dense
    >
    </v-select>
  </div>
</template>
<script>
export default {
  name: "SelectSportFilter",
  data: (_this) => ({
    sport: { text: _this.$t("sports"), value: "sports" },
  }),
  watch: {
    selectStore(sport) {
      this.sport = sport;
    },
  },
  computed: {
    selectStore() {
      return this.$store.state.filters.selectSport;
    },
    icon() {
      return this.sport.value === "casino" ? "mdi-dice-6" : "mdi-soccer";
    },
    items() {
      return [
        { text: this.$t("sports"), value: "sports" },
        { text: this.$t("casino"), value: "casino" },
      ];
    },
  },
  methods: {
    setSelectSport() {
      this.$store.commit("setSelectSport", this.sport);
    },
  },
};
</script>
